module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer",
    staticStyle: {
      "margin-left": "0",
      "height": "250px",
      "line-height": "18px"
    },
    style: (_vm.footerStyle)
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    staticStyle: {
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "footer_content",
    attrs: {
      "id": "footer_content"
    }
  }, [_c('div', {
    staticClass: "content_main fifteen_width"
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("产品")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("精准获客+CRM平台")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("企业数据中心")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("投融资数据平台")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("企业风控数据平台")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_main fifteen_width"
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("数据服务")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("客户精准推荐模型")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("企业创新能力评估模型")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("企业风控能力评估模型")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("大数据清洗服务")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_main fifteen_width"
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("招商加盟")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("加盟商通道")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("服务商查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_main fifteen_width"
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("关于我们")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("公司简介")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("招贤纳士")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_main twenty_width"
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("电话：010-82810650")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("邮箱：market@dataadt.com")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("Q Q：514027267")])]), _vm._v(" "), _c('div', {
    staticClass: "content_div"
  }, [_c('a', {
    staticClass: "content_font"
  }, [_vm._v("Q 群：779652138")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_main twenty_width",
    staticStyle: {
      "height": "250px"
    }
  }, [_c('div', {
    staticClass: "header_font"
  }, [_c('span', [_vm._v("企通查APP")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90px",
      "height": "110px",
      "float": "left"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/img/home/Android.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('span', {
    staticClass: "content_font"
  }, [_vm._v("Android")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90px",
      "height": "110px",
      "float": "left"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/img/home/iOS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "24px"
    }
  }, [_c('span', {
    staticClass: "content_font"
  }, [_vm._v("iOS")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "float": "left",
      "padding-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80px",
      "height": "26px",
      "border-radius": "4px",
      "padding-top": "4px",
      "padding-left": "10px",
      "border": "1px solid #e3e3e3"
    }
  }, [_c('a', {
    staticClass: "content_font",
    attrs: {
      "id": "online"
    }
  }, [_vm._v("在线咨询")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794fa125"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Footer.vue
// module id = 1095
// module chunks = 284